import theme from '@styles/theme';
const styles = {
  modalHeading: {
    padding: '0 16px',
    maxHeight: '925px'
  },
  modalContainer: (isSuccess: boolean) => ({
    display: isSuccess ? 'flex' : 'block',
    justifyContent: isSuccess ? 'center' : 'flex-start',
    fontFamily: `${theme.fonts.uniformMedium} !important`
  }),
  modalHeadingText: {
    fontWeight: `${theme.fontWeights.medium} !important`,
    lineHeight: '24px !important',
    letterSpacing: '1.2px !important',
    fontFamily: `${theme.fonts.uniformMedium} !important`
  },
  modalContent: {
    padding: ['24px 16px', '24px 16px', '24px 40px'],
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: '8px',
    scrollbarWidth: '42px',
    scrollbarColor: `${theme.rawColors.darkGrey700} ${theme.rawColors.lightGrey300}`,
    '&::-webkit-scrollbar': {
      width: '2px',
      background: theme.rawColors.neutralWhite,
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-track': {
      background: theme.rawColors.lightGrey500
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '2px',
      background: theme.rawColors.darkGrey700
    },
    [`@media (max-width: ${theme.breakpoints[2]})`]: {
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '0px'
      }
    }
  },
  section: {
    marginBottom: '24px',
    paddingLeft: '4px',
    '&:last-of-type': {
      marginBottom: '8px'
    }
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: '400',
    color: 'darkGrey700',
    margin: '0 0 24px 0'
  },
  productContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '12px'
  },
  productNameInput: {
    marginBottom: '0px',
    flex: 1
  },
  copyUrlButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '48px',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'lightGrey200'
    },
    '&:active': {
      backgroundColor: 'lightGrey300'
    }
  },
  productLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    backgroundColor: 'lightGrey200',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'lightGrey300'
    }
  },
  colorInput: {
    width: '200px'
  },
  colorTile: {
    width: 'max-content',
    padding: '4px 6px 4px 12px',
    backgroundColor: 'lightGrey200',
    border: '1px solid',
    borderColor: 'lightGrey400',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    cursor: 'default'
  },
  colorTileLabel: {
    fontSize: '12px',
    color: 'darkGrey500',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  colorTileValue: {
    fontSize: '14px',
    color: 'darkGrey700',
    fontWeight: '400'
  },
  fullNameInput: {
    marginBottom: '16px'
  },
  postalCodeInput: {
    marginBottom: '12px'
  },
  emailInput: {
    marginBottom: '12px'
  },
  phoneContainer: {
    display: 'flex',
    gap: '16px',
    marginBottom: '12px'
  },
  phoneCountryCodeSelect: {
    width: '120px',
    marginBottom: '0px'
  },
  phoneNumberInput: {
    flex: 1,
    marginBottom: '0px'
  },
  requiredFieldsNote: {
    fontSize: '12px',
    color: 'darkGrey500'
  },
  commentTextarea: {
    minHeight: '120px'
  },
  footer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: ['12px', '12px', '40px'],
    marginTop: 'auto',
    paddingTop: '24px',
    borderTop: '1px solid',
    borderTopColor: 'lightGrey300',
    flexShrink: 0
  },
  consentContainer: {
    flex: 1,
    maxWidth: '550px'
  },
  consentText: {
    fontSize: '14px',
    color: 'darkGrey700',
    lineHeight: '1.4'
  },
  regulationsLink: {
    textDecoration: 'underline',
    color: 'darkGrey700 !important'
  },
  submitButton: {
    minWidth: '200px',
    height: '60px',
    fontFamily: theme.fonts.uniformMedium,
    fontSize: '16px',
    fontWeight: theme.fontWeights.medium,
    lineHeight: '140%',
    letterSpacing: '1.6px',
    flex: 'auto',
    width: ['100%', '100%', 'auto']
  },
  // Success screen styles
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '40px 20px',
    flex: 1
  },
  successFooter: {
    borderTop: '1px solid',
    borderTopColor: 'lightGrey300',
    paddingTop: '24px',
    paddingBottom: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  successIconContainer: {
    padding: '64px',
    marginBottom: '24px'
  },
  successIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: '2px solid',
    borderColor: 'darkGrey700'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  successTitle: {
    fontSize: '20px',
    fontStyle: 'normal',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    letterSpacing: '1px',
    lineHeight: '140%',
    color: 'darkGrey700',
    marginBottom: '8px',
    textAlign: 'center'
  },
  successMessage: {
    fontSize: '16px',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    color: 'darkGrey700'
  },
  closeButton: {
    width: '100%',
    fontFamily: theme.fonts.uniform,
    height: '58px',
    fontWeight: theme.fontWeights.medium,
    lineHeight: '140%',
    fontSize: '16px'
  },
  checkboxContainer: {
    gap: '8px'
  }
};
export default styles;